import React, { useState } from 'react';
import { FaLocationDot } from "react-icons/fa6";
import { FaPhoneAlt } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ts, validatePhoneNumber } from '../utils/metaData';
import { FaCheck } from "react-icons/fa";
import connect1 from '../../assets/connect1.jpeg'
import connect2 from '../../assets/connect2.jpeg'

const Connect = () => {
    const [data, setData] = useState({
        name: '',
        phone: '',
        email: '',
        message: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({
            ...data,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!data.name || !data.phone || !data.email || !data.message) {
            toast.error("All fields are required.");
            return;
        }

        if (!validatePhoneNumber(data.phone)) {
            toast.error("Invalid Phone Number");
            return;
        }

        try {
            const headers = {
                "Content-Type": "application/json",
                "pid": "INVST"
            }
            const body = JSON.stringify({
                meta: {
                    pid: "INVST",
                    appName: "investycoons",
                    ts: ts(),
                    reqAction: "connect",
                    location: "N/A",
                },
                pay: {
                    phone: data.phone,
                    name: data.name,
                    email: data.email,
                    message: data.message
                }
            })
            const response = await fetch(`${process.env.REACT_APP_BASEURL}/user/connect`, {
                method: "POST",
                body: body,
                headers: headers,
            })
            const res = await response.json()
            if (res.statusCode == '000') {
                toast.success(res.message)
            }
            else {
                toast.error(res.message)
            }
            setData({
                name: "",
                phone: "",
                email: "",
                message: ""
            })
        } catch (error) {
            toast.error("Something Went Wrong !");
        }
    }


    return (
        <>
            <div className='bg-slate-200 pt-16'>
                <ToastContainer />
                <div className="py-12">
                    <h2 className="text-black font-bold text-3xl mb-10 text-center">Let's Grow With us, Connect Now !</h2>

                    <section className="relative py- 8bg-slate-50">
                        <div className="container mx-auto px-6 lg:px-12">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
                                <div>
                                    <div className="max-w-sm flex items-start rounded-xl bg-white p-6 shadow-lg mb-8 md:ml-12">
                                        <div className="flex h-12 w-12 items-center justify-center rounded-full border border-green-600 bg-green-600">
                                            <FaPhoneAlt size={22} color="white" />
                                        </div>
                                        <div className="ml-4">
                                            <h2 className="font-semibold">Phone</h2>
                                            <p className="mt-2 text-sm text-gray-500">+91 9311051597</p>
                                        </div>
                                    </div>

                                    <div className="max-w-sm flex items-start rounded-xl bg-white p-6 shadow-lg mb-8 md:ml-12">
                                        <div className="flex h-12 w-12 items-center justify-center rounded-full border border-green-600 bg-green-600">
                                            <IoMdMail size={25} color="white" />
                                        </div>
                                        <div className="ml-4">
                                            <h2 className="font-semibold">Email</h2>
                                            <p className="mt-2 text-sm text-gray-500">connect@investycoons.com</p>
                                        </div>
                                    </div>

                                    <div className="max-w-sm flex items-start rounded-xl bg-white p-6 shadow-lg mb-4 md:ml-12">
                                        <div className="flex h-12 w-12 items-center justify-center rounded-full border border-green-600 bg-green-600">
                                            <FaLocationDot size={22} color="white" />
                                        </div>
                                        <div className="ml-4">
                                            <h2 className="font-semibold">Office Address</h2>
                                            <p className="mt-2 text-sm text-gray-500">NOIDA,  Uttar Pradesh,  201301, INDIA</p>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <form className="bg-white shadow-lg rounded-lg p-4 md:p-6 max-w-lg mx-auto md:mx-0 w-full" onSubmit={handleSubmit}>
                                        <div className="mb-3">
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                                            <input
                                                type="text"
                                                name="name"
                                                placeholder="Your Name"
                                                value={data.name}
                                                onChange={handleChange}
                                                className="w-full p-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-500"
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
                                            <input
                                                type="tel"
                                                name="phone"
                                                placeholder="Your Phone Number"
                                                value={data.phone}
                                                onChange={handleChange}
                                                maxLength="10"
                                                className="w-full p-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-500"
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                                            <input
                                                type="email"
                                                name="email"
                                                placeholder="Your Email"
                                                value={data.email}
                                                onChange={handleChange}
                                                className="w-full p-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-500"
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Message</label>
                                            <textarea
                                                name="message"
                                                placeholder="Your Message"
                                                value={data.message}
                                                onChange={handleChange}
                                                className="w-full p-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-500"
                                            />
                                        </div>

                                        <button
                                            type="submit"
                                            className="w-full bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition"
                                        >
                                            Submit
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </section>


                    <div className='grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 w-full px-6 md:px-8 pt-[40px] md:pt-[60px]'>
                        {/* Image Section */}
                        <div className='flex justify-center md:justify-start px-4 md:px-6'>
                            <img className='h-[300px] md:h-[300px] w-full max-w-[400px] object-cover' src={connect1} alt='img' />
                        </div>

                        {/* Text Content */}
                        <div className='flex justify-center items-center px-4 md:px-0'>
                            <div className='text-center md:text-left'>
                                <h3 className="text-xl md:text-2xl font-semibold text-black mb-4">
                                    Got Real Estate Goals? Let’s Make Them Happen!
                                </h3>
                                <p className="text-justify mt-3 text-sm md:text-base">
                                    At Investycoons, we believe that the right investment starts with the right conversation.
                                    Whether you're looking for luxury apartments, high-yield commercial properties, pre-leased
                                    investments, or exclusive land deals, our team is here to guide you.
                                </p>
                                <p className="text-justify mt-3 text-sm md:text-base">
                                    From first-time investors to seasoned property buyers, we help you navigate the market with expert
                                    insights, exclusive opportunities, and end-to-end investment support. Let’s connect and take the first
                                    step toward securing your financial future!
                                </p>
                            </div>
                        </div>
                    </div>


                    <div className='grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 w-full px-6 md:px-8 pt-[60px] md:pt-[80px]'>
                        {/* Text Section */}
                        <div className='flex justify-center items-center px-4 md:px-0 text-center md:text-left'>
                            <div>
                                <h3 className="text-xl md:text-2xl font-semibold text-black mt-6 md:mt-8 mb-4">
                                    How Can We Help You?
                                </h3>
                                <ul className="list-none p-0 mt-3 space-y-3">
                                    <li className="text-gray-800 text-sm md:text-base flex items-start md:items-center gap-2 text-justify">
                                        <FaCheck className="text-green-600 mt-1 md:mt-0 shrink-0" />
                                        Looking for investment opportunities? We’ll help you find the best properties with high ROI and long-term appreciation.
                                    </li>
                                    <li className="text-gray-800 text-sm md:text-base flex items-start md:items-center gap-2 text-justify">
                                        <FaCheck className="text-green-600 mt-1 md:mt-0 shrink-0" />
                                        Need expert advice? Our real estate consultants will provide personalized recommendations based on your investment goals.
                                    </li>
                                    <li className="text-gray-800 text-sm md:text-base flex items-start md:items-center gap-2 text-justify">
                                        <FaCheck className="text-green-600 mt-1 md:mt-0 shrink-0" />
                                        Have questions about financing? We’ll guide you through the best home loan and commercial property financing options.
                                    </li>
                                    <li className="text-gray-800 text-sm md:text-base flex items-start md:items-center gap-2 text-justify">
                                        <FaCheck className="text-green-600 mt-1 md:mt-0 shrink-0" />
                                        NRI Investor? We offer complete assistance for NRIs looking to invest in Indian real estate, including legal and documentation support.
                                    </li>
                                    <li className="text-gray-800 text-sm md:text-base flex items-start md:items-center gap-2 text-justify">
                                        <FaCheck className="text-green-600 mt-1 md:mt-0 shrink-0" />
                                        Need a property valuation or market insights? Our team provides data-driven analysis to help you make informed decisions.
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/* Image Section */}
                        <div className='flex justify-center md:justify-end px-4 md:px-8'>
                            <img className='h-[250px] md:h-[350px] w-full max-w-[450px] object-cover' src={connect2} alt='img' />
                        </div>
                    </div>



                    {/* <div className="mt-12">
                        <h3 className="text-2xl font-semibold text-black mb-6 text-center">Send Us a Message</h3>
                        <form className="bg-white shadow-lg rounded-lg p-8 max-w-lg mx-auto" onSubmit={handleSubmit}>
                            <div className="mb-4 text-left">
                                <label className="block text-sm font-medium text-gray-700 mb-2">Name</label>
                                <input type="text" name="name" placeholder="Your Name" value={data.name} onChange={handleChange} className="w-full p-3 rounded-lg border border-gray-300" />
                            </div>

                            <div className="mb-4 text-left">
                                <label className="block text-sm font-medium text-gray-700 mb-2">Phone</label>
                                <input type="tel" name="phone" placeholder="Your Phone Number" value={data.phone} onChange={handleChange} maxLength="10" className="w-full p-3 rounded-lg border border-gray-300" />
                            </div>

                            <div className="mb-4 text-left">
                                <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                                <input type="email" name="email" placeholder="Your Email" value={data.email} onChange={handleChange} className="w-full p-3 rounded-lg border border-gray-300" />
                            </div>

                            <div className="mb-4 text-left">
                                <label className="block text-sm font-medium text-gray-700 mb-2">Message</label>
                                <textarea name="message" placeholder="Your Message" value={data.message} onChange={handleChange} className="w-full p-3 rounded-lg border border-gray-300"></textarea>
                            </div>

                            <button type="submit" className="w-full bg-green-600 text-white py-3 rounded-lg hover:bg-green-700 transition">
                                Submit
                            </button>
                        </form>
                    </div> */}

                </div>
            </div>


        </>

    );
}
export default Connect;